import { CLASSROOM_MODULE_DISPLAY_REVERT_MODAL } from '../actions';
import { getVersions } from '../api';
import * as classRoomSelectors from '../../selectors/classroom';
import * as materialsSelectors from '../selectors';

const displayRevertModalAction = (status, payload) => ({
  type: CLASSROOM_MODULE_DISPLAY_REVERT_MODAL,
  status,
  payload,
});

const displayRevertModalStarted = displayRevertModalAction.bind(
  null,
  'started'
);
const displayRevertModalSuccess = displayRevertModalAction.bind(
  null,
  'success'
);
const displayRevertModalError = displayRevertModalAction.bind(null, 'error');

const displayRevertModal = async (dispatch, getState, sectionId) => {
  const state = getState();
  const classRoom = classRoomSelectors.currentClassRoomId(state);
  const section = materialsSelectors.getMaterial(state, sectionId);

  const payload = {
    classRoom,
    section,
  };
  dispatch(displayRevertModalStarted(payload));

  if (!section) {
    return;
  }

  try {
    const versions = await getVersions(classRoom, sectionId);
    dispatch(
      displayRevertModalSuccess({
        ...payload,
        section: { ...section, versions },
      })
    );
  } catch (error) {
    dispatch(displayRevertModalError(payload));
  }
};

export default (sectionId) => (dispatch, getState) =>
  displayRevertModal(dispatch, getState, sectionId);
